export default function Logo({ size = 40, className = "" }) {
    return (
        <img
            src="/logo.png"
            alt="VIDMAR"
            width={size}
            height={size}
            className={`rounded-full object-cover ${className}`}
            data-testid="vidmar-logo"
        />
    );
}
